import { makeAutoObservable } from 'mobx';
interface NumberZero {
  key: string;
  text: string;
  value: string;
  zero: string;
}

interface workflowConfiguration {
  // asset Type
  assetTypeIsActive: boolean;
  showassetTypeName: string;
  assetTypeKey: number | null;

  // Type Elements
  showElementTypesName: string;
  showElementTypesCard: boolean;

  // Template
  showTemplateCard: boolean;
  showTemplateName: string;

  // Tasks
  showTaskName: string;
  showTaskCard: boolean;

  // SubTasks
  subTaskName: string;
  showSubTaskCard: boolean;
  showSubTaskClicked: boolean;

  // Elements
  showElementName: string;
  showElementCard: boolean;
  showElementClicked: boolean;

  //metadata and template
  showMetaDataTemplateCard: boolean;
  showMetaDataTemplateCardName: string;

  //metaData
  showMetaDataCard: boolean;

  // Options
  ShowCommunication: string;
  // disable enable click
  disableClick: boolean;
  //edit all data
  editClickedElementType: boolean;
  editClickedAssetype: boolean;
  editClickedTemplate: boolean;
  editClickedTask: boolean;
  editClickedSubtask: boolean;
  editClickedElement: boolean;

  ////////////////////////roles and permissions

  //roles
  showRoleId: string;
  //types
  setShowTypesName: string;
  showTypesCard: boolean;
  //////*Parent*/  Pages
  showPageName: string;
  showPageCard: boolean;
  //Components
  componentClicked: boolean;
  showComponentName: string;
  showComponentCard: boolean;
  //features
  featuresClicked: boolean;
  showFeaturesCard: boolean;

  //dynamic Rules
  setDynamicRulesName: string;
  showDynamicRulesCard: boolean;
  //show customers
  showCustomersCard: boolean;
  //show Departments
  showDepartmentsCard: boolean;
  //asset type Dynamic Rule
  showAssetTypeCard: boolean;
  // Roles - Asset type
  elementTypeClicked: boolean;
  //Roles-Element Type
  templateClicked: boolean;
  //Roles-Task Cliked
  taskClicked: boolean;
  //workflow Settings Barcode
  barcodeType: string;
  barcodeValue0: string;
  barcodeValue1: string;
  barcodeValue2: string;
  incrementalValues: NumberZero[];
  metaDataConfigurationName: string;
  dynamicDropdownList: any[];
}
const initialState = {
  assetTypeIsActive: false,
  showassetTypeName: '',
  assetTypeKey: null,
  // Type Elements
  showElementTypesName: '',
  showElementTypesCard: false,
  // Template
  showTemplateCard: false,
  showTemplateName: '',
  // Tasks
  showTaskName: '',
  showTaskCard: true,
  // SubTasks
  subTaskName: '',
  showSubTaskCard: false,
  showSubTaskClicked: true,
  // Elements
  showElementName: '',
  showElementCard: false,
  showElementClicked: true,
  //metadata and template
  showMetaDataTemplateCard: false,
  showMetaDataTemplateCardName: '',
  //metadata
  showMetaDataCard: false,
  // Options
  ShowCommunication: '',
  // disable enable click
  disableClick: false,
  //edit
  editClickedElementType: false,
  editClickedAssetype: false,
  editClickedTemplate: false,
  editClickedTask: false,
  editClickedSubtask: false,
  editClickedElement: false,
  //////////////////////////// //roles and permissions

  //roles
  showRoleId: '',
  //types
  setShowTypesName: '',
  showTypesCard: false,
  //////*Parent* Pages
  showPageName: '',
  showPageCard: false,
  //Components
  componentClicked: false,
  showComponentName: '',
  showComponentCard: false,
  //features
  featuresClicked: false,
  showFeaturesCard: false,
  //////*Parent* Dynamic Rules
  setDynamicRulesName: '',
  showDynamicRulesCard: false,
  //show customers
  showCustomersCard: false,
  //show Departments
  showDepartmentsCard: false,
  //asset type Dynamic Rule
  showAssetTypeCard: false,
  // Roles - Asset type
  elementTypeClicked: false,
  //Roles-Element Type
  templateClicked: false,
  //Roles-Task Clicked
  taskClicked: false,
  //workflow Settings Barcode
  barcodeType: '',
  barcodeValue0: '',
  barcodeValue1: '',
  barcodeValue2: '',
  metaDataConfigurationName: '',
  incrementalValues: [
    { key: '1', text: '01', value: '01', zero: '0' },
    { key: '2', text: '001', value: '001', zero: '00' },
    { key: '3', text: '0001', value: '0001', zero: '000' },
    { key: '4', text: '00001', value: '00001', zero: '000' },
    { key: '5', text: '000001', value: '000001', zero: '000' },
    { key: '6', text: '0000001', value: '0000001', zero: '000' },
  ],
  dynamicDropdownList: [],
};
export default class WorkflowConfigurationStore {
  WorkflowConfiguration: workflowConfiguration = initialState;

  constructor() {
    makeAutoObservable(this);
  }
  // asset Type
  setAssetTypeIsActive = (e: boolean) => {
    this.WorkflowConfiguration.assetTypeIsActive = e;
  };

  setShowAssetTypeName = (e: string) => {
    this.WorkflowConfiguration.showassetTypeName = e;
  };
  setAssetTypeKey = (e: number | null) => {
    this.WorkflowConfiguration.assetTypeKey = e;
  };

  // Type Elements

  setShowElementTypesName = (e: string) => {
    this.WorkflowConfiguration.showElementTypesName = e;
  };

  setShowElementTypesCard = (e: boolean) => {
    this.WorkflowConfiguration.showElementTypesCard = e;
  };

  //metadata template
  setMetaDataTemplateName = (e: string) => {};
  setShowMetaDataTemplateCard = (e: boolean) => {
    this.WorkflowConfiguration.showMetaDataTemplateCard = e;
  };
  setShowMetaDataTemplateCardName = (name: string) => {
    this.WorkflowConfiguration.showMetaDataTemplateCardName = name;
  };
  setShowMetaDataCard = (e: boolean) => {
    this.WorkflowConfiguration.showMetaDataCard = e;
  };
  // Template
  setShowTemplateCard = (e: boolean) => {
    this.WorkflowConfiguration.showTemplateCard = e;
  };
  setShowTemplateName = (e: string) => {
    this.WorkflowConfiguration.showTemplateName = e;
  };

  // Tasks
  setTaskName = (e: string) => {
    this.WorkflowConfiguration.showTaskName = e;
  };
  setShowTaskCard = (e: boolean) => {
    this.WorkflowConfiguration.showTaskCard = e;
  };
  // SubTasks
  setShowSubTaskClicked = (e: boolean) => {
    this.WorkflowConfiguration.showSubTaskClicked = e;
  };
  setSubTaskName = (e: string) => {
    this.WorkflowConfiguration.subTaskName = e;
  };

  setShowSubTaskCard = (e: boolean) => {
    this.WorkflowConfiguration.showSubTaskCard = e;
  };

  // Elements
  setShowElementName = (e: string) => {
    this.WorkflowConfiguration.showElementName = e;
  };
  setShowElementCard = (e: boolean) => {
    this.WorkflowConfiguration.showElementCard = e;
  };

  setShowElementClicked = (e: boolean) => {
    this.WorkflowConfiguration.showElementClicked = e;
  };
  // Options
  setShowCommunication = (e: string) => {
    this.WorkflowConfiguration.ShowCommunication = e;
  };
  //enable disable click
  setDisableClick = (e: boolean) => {
    this.WorkflowConfiguration.disableClick = e;
  };
  //edit condition
  setEditClickedElementType = (e: boolean) => {
    this.WorkflowConfiguration.editClickedElementType = e;
  };
  //edit condition Asset Type
  setEditClickedAssetType = (e: boolean) => {
    this.WorkflowConfiguration.editClickedAssetype = e;
  };
  //edit condition Template
  setEditClickedTemplate = (e: boolean) => {
    this.WorkflowConfiguration.editClickedTemplate = e;
  };
  //edit condition Task
  setEditClickedTask = (e: boolean) => {
    this.WorkflowConfiguration.editClickedTask = e;
  };
  //edit condition Subtask
  setEditClickedSubTask = (e: boolean) => {
    this.WorkflowConfiguration.editClickedSubtask = e;
  };
  //edit condition Element
  setEditClickedElement = (e: boolean) => {
    this.WorkflowConfiguration.editClickedElement = e;
  };
  ////////////////////////////////roles for page component

  //roles
  setShowRoleId = (e: string) => {
    this.WorkflowConfiguration.showRoleId = e;
  };

  //types
  setShowTypesName = (e: string) => {
    this.WorkflowConfiguration.setShowTypesName = e;
  };
  setShowTypesCard = (e: boolean) => {
    this.WorkflowConfiguration.showTypesCard = e;
  };

  //////////*Parent*/ pages
  setShowPageName = (e: string) => {
    this.WorkflowConfiguration.showPageName = e;
  };
  setShowPagesCard = (e: boolean) => {
    this.WorkflowConfiguration.showPageCard = e;
  };

  //Components
  setShowComponentClicked = (e: boolean) => {
    this.WorkflowConfiguration.componentClicked = e;
  };

  setShowComponentName = (e: string) => {
    this.WorkflowConfiguration.showComponentName = e;
  };
  setShowComponentCard = (e: boolean) => {
    this.WorkflowConfiguration.showComponentCard = e;
  };
  //features
  setShowFeatuesClicked = (e: boolean) => {
    this.WorkflowConfiguration.featuresClicked = e;
  };
  setShowFeaturesCard = (e: boolean) => {
    this.WorkflowConfiguration.showFeaturesCard = e;
  };
  //dynamic Rules
  setShowDynmaicRulesName = (e: string) => {
    this.WorkflowConfiguration.setDynamicRulesName = e;
  };
  setShowDynamicRulesCard = (e: boolean) => {
    this.WorkflowConfiguration.showDynamicRulesCard = e;
  };
  //customers Card
  setShowCustomersCard = (e: boolean) => {
    this.WorkflowConfiguration.showCustomersCard = e;
  };
  //Deparments Card
  setShowDepartmentsCard = (e: boolean) => {
    this.WorkflowConfiguration.showDepartmentsCard = e;
  };
  //dynamic Asset type
  setShowAssetTypeCard = (e: boolean) => {
    this.WorkflowConfiguration.showAssetTypeCard = e;
  };
  // Roles - Element type
  setShowElementTypeClicked = (e: boolean) => {
    this.WorkflowConfiguration.elementTypeClicked = e;
  };
  // Roles - Template type
  setShowTemplateClicked = (e: boolean) => {
    this.WorkflowConfiguration.templateClicked = e;
  };
  //Roles - Tasks
  setShowTaskClicked = (e: boolean) => {
    this.WorkflowConfiguration.taskClicked = e;
  };
  //set barcode type
  setBarcodeType = (e: string) => {
    this.WorkflowConfiguration.barcodeType = e;
  };
  //set barcode type
  setBarcodeValue0 = (e: string) => {
    this.WorkflowConfiguration.barcodeValue0 = e;
  };
  //set barcode type
  setBarcodeValue1 = (e: string) => {
    this.WorkflowConfiguration.barcodeValue1 = e;
  };
  //set barcode type
  setBarcodeValue2 = (e: string) => {
    this.WorkflowConfiguration.barcodeValue2 = e;
  };

  resetWorkflowConfigData() {
    this.WorkflowConfiguration.assetTypeIsActive = false;
    this.WorkflowConfiguration.showassetTypeName = '';
    this.WorkflowConfiguration.assetTypeKey = null;
    // Type Elements
    this.WorkflowConfiguration.showElementTypesName = '';
    this.WorkflowConfiguration.showElementTypesCard = false;
  }

  resetEditClickedButtonExceptAssetType = () => {
    this.setEditClickedTemplate(false);
    this.setEditClickedElementType(false);
    this.setEditClickedTask(false);
    this.setEditClickedSubTask(false);
    this.setEditClickedElement(false);
  };

  resetEditClickedButtonExceptElementType = () => {
    this.setEditClickedTemplate(false);
    this.setEditClickedAssetType(false);
    this.setEditClickedTask(false);
    this.setEditClickedSubTask(false);
    this.setEditClickedElement(false);
  };
  resetEditClickedButtonExceptTemplate = () => {
    this.setEditClickedElementType(false);
    this.setEditClickedAssetType(false);
    this.setEditClickedTask(false);
    this.setEditClickedSubTask(false);
    this.setEditClickedElement(false);
  };
  resetEditClickedButtonExceptTask = () => {
    this.setEditClickedElementType(false);
    this.setEditClickedAssetType(false);
    this.setEditClickedTemplate(false);
    this.setEditClickedSubTask(false);
    this.setEditClickedElement(false);
  };
  resetEditClickedButtonExceptSubTask = () => {
    this.setEditClickedElementType(false);
    this.setEditClickedAssetType(false);
    this.setEditClickedTemplate(false);
    this.setEditClickedTask(false);
    this.setEditClickedElement(false);
  };
  resetEditClickedButtonExceptElements = () => {
    this.setEditClickedElementType(false);
    this.setEditClickedAssetType(false);
    this.setEditClickedTemplate(false);
    this.setEditClickedTask(false);
    this.setEditClickedSubTask(false);
  };

  //reset to intiial State
  resetWorkflowConfigurationStore = () => {
    this.WorkflowConfiguration = initialState;
  };
}
